import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import * as ConstantOptions from '../../Utils/ConstantOptions';
import compair from "../../CommonComponent/SortDropDown";
import Select from '../../CommonComponent/ReactSelect';
import { editIconTooltip, deleteIconTooltip, saveIconTooltip, resetIconTooltip, updateIconTooltip, exampleIconTooltip } from '../../CommonComponent/CommonIconTooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import formatDisplayData from '../../CommonComponent/DisplayContentFormatter';
import isEmptyValidation from '../../Validation/EmptyError';
import InputMask from "../../CommonComponent/NumberFormat";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import commercialDemoImage from '../../../assets/images/commercial.png';
import medicarePartD_DemoImage from '../../../assets/images/medicare-part-D.png';

let constantOptions = ConstantOptions.DROPDOWN_OPTIONS

const InsuranceTab = forwardRef((props,ref) => {
    let insuranceData = props.insuranceData;
    let setInsuranceData = props.setInsuranceData;
    let setInsuranceDataTemp = props.setInsuranceDataTemp;

    const [insuranceType, setInsuranceType] = useState();
    const [editedIndexForInsurance, setEditedIndexForInsurance] = useState(null);
    const [insuranceTypeisEmpty, setInsuranceTypeisEmpty] = useState(false);

    const [BIN, setBIN] = useState("");
    const [BINisEmpty,setBINisEmpty] = useState(false);
    const [PCN, setPCN] = useState("");
    const [PCNisEmpty,setPCNisEmpty] = useState(false);
    const [group, setGroup] = useState("");
    const [groupisEmpty,setGroupisEmpty] = useState(false);
    const [idNumber, setIdNumber] = useState("");
    const [idNumberisEmpty,setIdNumberisEmpty] = useState(false);
    const [personCode, setPersonCode] = useState("");
    const [personCodeisEmpty,setPersonCodeisEmpty] = useState(false);
    const [otherDescription,setOtherDescription] = useState("");
    const [otherDescriptionIsEmpty,setOtherDescriptionIsEmpty] = useState(false);

    const [modelShow, setModelShow] = useState(false);
    const [popupImage, setPopupImage] = useState("");
    const [popupTitle, setPopupTitle] = useState("");
    
    useImperativeHandle(ref, () => ({
        resetInsuranceOnClickOfSubmit() {
            resetInsurance();
        }
    }));

    useEffect(()=>{
        isValidForSaveOnClickOfSubmit();
    },[insuranceType,BIN,PCN,group,idNumber,personCode,otherDescription]);

    const isValidForSaveOnClickOfSubmit = () =>{
        if(insuranceType !== undefined && insuranceType !== null && insuranceType.value !== undefined && insuranceType.value !== ""  && BIN !== "" && idNumber !== "")
        {
            if(validateInsurance(false))
            {
                saveInsuranceInTemp();
            }
        }
        else{
            setInsuranceDataTemp([]);
        }
    }

    const saveInsuranceInTemp=()=>{
    
        setInsuranceDataTemp([]);
        let insArray=[];
        let addToArrayValuesTemp = {
            settedInsuranceType: insuranceType !== "" ? insuranceType : "",
            settedBin : BIN !== "" ? BIN : "",
            settedPcn : PCN !== "" ? PCN : "",
            settedGroup : group !== "" ? group : "",
            settedIdNumber : idNumber !== "" ? idNumber : "",
            settedPersonCode : personCode !== "" ? personCode : "",
            settedOtherDescription : otherDescription !== "" ? otherDescription : ""
        };
        if (editedIndexForInsurance != null) {
            addToArrayValuesTemp = { ...addToArrayValuesTemp, "id": editedIndexForInsurance }
        }
        else {
            addToArrayValuesTemp = { ...addToArrayValuesTemp, "id": insuranceData !== [] && insuranceData.length!==0 ? insuranceData[insuranceData.length-1].id + 1 : 1 }
        }
        insArray.push(addToArrayValuesTemp);
        setInsuranceDataTemp(insArray);
    }


    const handleModelClose = () => setModelShow(false);
    const handleModelShow = () => {

        setModelShow(true);
        
        if(insuranceType !== undefined && insuranceType !== null && insuranceType.label === "Commercial")
        {
            setPopupImage(commercialDemoImage);
            setPopupTitle("Commercial");
        }
        else if(insuranceType !== undefined && insuranceType !== null && insuranceType.label === "Medicare Part-D")
        {
            setPopupImage(medicarePartD_DemoImage);
            setPopupTitle("Medicare Part-D");
        }
     
    };
    
    const validateInsurance = (isFromSubmit) => {
        let isValidInsurance = true;
        
        if(!isEmptyValidation(insuranceType,setInsuranceTypeisEmpty))
             isValidInsurance=false

    
        if(insuranceType !== undefined && insuranceType !== null && insuranceType !== ""  && insuranceType.label !== "")
        {
            if(!isEmptyValidation(BIN,setBINisEmpty) || BIN.replace(/-|\s/g, "").length !== 6)
                {isValidInsurance=false; setBINisEmpty(true);}
            else
                {isValidInsurance=true; setBINisEmpty(false);}

            if(!isEmptyValidation(idNumber,setIdNumberisEmpty))
                isValidInsurance=false

            if(insuranceType.label === "Other" && !isEmptyValidation(otherDescription,setOtherDescriptionIsEmpty))
            {
                    isValidInsurance=false 
            }
        }

        if (isValidInsurance) {
            if(isFromSubmit)
            saveInsurance();
            else
                return true;
        }
    }

    const saveInsurance = e => {

        let addToArrayValues = {
            settedInsuranceType: insuranceType !== "" ? insuranceType : "",
            settedBin : BIN !== "" ? BIN : "",
            settedPcn : PCN !== "" ? PCN : "",
            settedGroup : group !== "" ? group : "",
            settedIdNumber : idNumber !== "" ? idNumber : "",
            settedPersonCode : personCode !== "" ? personCode : "",
            settedOtherDescription : otherDescription !== "" ? otherDescription : ""
        };

        if (editedIndexForInsurance != null) {

            addToArrayValues = { ...addToArrayValues, "id": editedIndexForInsurance }
            let newArr = [...insuranceData];
            if (insuranceData !== [] && insuranceData.length !== 0) {
                insuranceData.forEach((item, index) => {
                    if (item.id === editedIndexForInsurance) {
                        newArr[index] = addToArrayValues;
                    }
                })
            }

            setInsuranceData(newArr);
        }
        else {
            addToArrayValues = { ...addToArrayValues, "id": insuranceData !== [] && insuranceData.length!==0 ? insuranceData[insuranceData.length-1].id + 1 : 1 }
            setInsuranceData([...insuranceData, addToArrayValues]);
        }

        resetInsurance();

    }

    const resetInsurance = e => {
        setInsuranceType(""); setBIN(""); setPCN(""); setGroup(""); setIdNumber(""); setPersonCode("");
        setEditedIndexForInsurance(null);
        setInsuranceTypeisEmpty(false); setBINisEmpty(false); setPCNisEmpty(false); setGroupisEmpty(false);
        setIdNumberisEmpty(false); setPersonCodeisEmpty(false);
    }

    const editInsurance = (editData) => {

        if (editData.id && editData.id !== "") {
            setEditedIndexForInsurance(editData.id);
        }

        if (editData !== "" && editData != null) {
            setInsuranceType(editData.settedInsuranceType); 
            setBIN(editData.settedBin);
            setPCN(editData.settedPcn);
            setGroup(editData.settedGroup);
            setIdNumber(editData.settedIdNumber);
            setPersonCode(editData.settedPersonCode);
            setOtherDescription(editData.settedOtherDescription);
            setInsuranceTypeisEmpty(false); 
        }

    }

    const deleteInsurance = (deleteData) => {

        if (deleteData.id && deleteData.id !== "") {
            let newArr = [...insuranceData];

            if (insuranceData !== [] && insuranceData.length !== 0) {
                insuranceData.forEach((item, index) => {
                    if (item.id === deleteData.id) {
                        newArr.splice(index, 1);
                    }
                })
            }

            setInsuranceData(newArr);
        }
    }

    const insuranceTypeHandleChange = insuranceType => {
        setInsuranceType(insuranceType); setInsuranceTypeisEmpty(false);
        setBIN(""); setPCN(""); setGroup(""); setIdNumber(""); setPersonCode(""); setOtherDescription("");
        setBINisEmpty(false); setPCNisEmpty(false); setGroupisEmpty(false); setIdNumberisEmpty(false);
        setPersonCodeisEmpty(false);  setOtherDescriptionIsEmpty(false);
    }

    const BINHandleChange = (BIN) =>{
        setBIN(BIN.target.value); setBINisEmpty(false);
    }

    const PCNHandleChange = (PCN) =>{
        setPCN(PCN.target.value); setPCNisEmpty(false);
    }

    const groupHandleChange = (group) =>{
        setGroup(group.target.value); setGroupisEmpty(false);
    }

    const idNumberHandleChange = (idNumber) =>{
        setIdNumber(idNumber.target.value); setIdNumberisEmpty(false);
    }

    const personCodeHandleChange = (personCode) =>{
        setPersonCode(personCode.target.value); setPersonCodeisEmpty(false);
    }

    const otherDescriptionHandleChange = (otherDescription) =>{
        setOtherDescription(otherDescription.target.value); setOtherDescriptionIsEmpty(false);
    }

    const setIconForInsurance = (row) => {
        return (
            <div>
                <OverlayTrigger placement={"bottom"} overlay={editIconTooltip}>
                    <span onClick={() => editInsurance(row)}><i className="fa fa-edit"></i></span>
                </OverlayTrigger>
                <OverlayTrigger placement={"bottom"} overlay={deleteIconTooltip}>
                    <span onClick={() => deleteInsurance(row)}><i className="fa fa-trash"></i></span>
                </OverlayTrigger>
            </div>
        );
    }

    const formatInsuranceType = (row) => {
        if(row.settedOtherDescription !== null && row.settedOtherDescription !== "")
        {
            return formatDisplayData(row.settedInsuranceType.label + " (" + row.settedOtherDescription + ")" ,'15')
        }
        return formatDisplayData(row.settedInsuranceType.label,'15');
    }

    return (
        <div className="inner-card">
            <div className="card-header">
            Insurance
         </div>
            <div className="card-inner-body">

                <Modal show={modelShow} onHide={handleModelClose} className="tds-modal-popup tds-modal-insurance">
                <Modal.Header closeButton>
                    <Modal.Title>{popupTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body ><img src={popupImage} alt={"example images"}/></Modal.Body>
                <Modal.Footer>
                    <Button className="btn-blue" variant="secondary" onClick={handleModelClose}>
                        <i className="fa fa-close"></i>
                    </Button>
                </Modal.Footer>                                             
                </Modal> 
         

                <div className="tds-row">
                    <div className="tds-column">
                        <div className={insuranceTypeisEmpty ? "tds-validation" : ""}>
                            <label htmlFor="insuranceType">Type*</label>
                            <Select
                                className={"custom_select_box"}
                                options={constantOptions.insuranceTypeOptions.sort(compair)}
                                id={"insuranceType"}
                                value={insuranceType}
                                handleChange={insuranceTypeHandleChange}
                            />
                        </div>
                    </div>
                    {insuranceType !== undefined && insuranceType !== null && insuranceType !== ""  && insuranceType.label !== ""
                    ?
                    <>
                    
                        {insuranceType.label === "Other"
                        ?
                        <div className="tds-column">
                            <div className={otherDescriptionIsEmpty ? "tds-validation" : ""}>
                                <label htmlFor="otherDescription">Description*</label>
                                <input type="text" id="otherDescription" name="otherDescription" 
                                value={otherDescription} onChange={otherDescriptionHandleChange} 
                                maxLength="50" autoComplete="none"
                                placeholder="Description" />
                            </div>
                        </div>
                        :
                        null}

                    <div className="tds-column">
                        <div className={BINisEmpty ? "tds-validation" : ""}>
                            <label htmlFor="BIN">BIN*</label>
                            <InputMask type="text" id="BIN" name="BIN" 
                            value={BIN} handleChange={BINHandleChange} maxLength="6"
                            pattern={"bin"} autoComplete="none"
                            placeholder="BIN" />
                        </div>
                    </div>
                    <div className="tds-column">
                        <div className={PCNisEmpty ? "tds-validation" : ""}>
                            <label htmlFor="PCN">PCN</label>
                            <input type="text" id="PCN" name="PCN" 
                            value={PCN} onChange={PCNHandleChange} maxLength="26" autoComplete="none"
                            placeholder="PCN" />
                        </div>
                    </div>
                    <div className="tds-column">
                        <div className={groupisEmpty ? "tds-validation" : ""}>
                            <label htmlFor="group">Group</label>
                            <input type="text" id="group" name="group"  autoComplete="none"
                            value={group} onChange={groupHandleChange} maxLength="26"
                            placeholder="Group" />
                        </div>
                    </div>
                    <div className="tds-column">
                        <div className={idNumberisEmpty ? "tds-validation" : ""}>
                            <label htmlFor="identificationNumber">Identification Number*</label>
                            <input type="text" id="identificationNumber" name="identificationNumber" 
                            value={idNumber} onChange={idNumberHandleChange} maxLength="50" autoComplete="none"
                            placeholder="Identification Number" />
                        </div>
                    </div>
                    {insuranceType.label !== "Medicare Part-D"?
                        <div className="tds-column">
                            <div className={personCodeisEmpty ? "tds-validation" : ""}>
                                <label htmlFor="personCode">Person Code</label>
                                <input type="text" id="personCode" name="personCode" autoComplete="none"
                                value={personCode} onChange={personCodeHandleChange}  maxLength="3"
                                placeholder="Person Code" />
                            </div>
                        </div>
                    :
                    null}
                    
                    </>
                    :
                    null
                    }

                    {insuranceType !== undefined && insuranceType !== null && insuranceType !== ""  && (insuranceType.label === "Commercial" || insuranceType.label === "Medicare Part-D")
                    ?
                    <div className={insuranceType.label === "Medicare Part-D" ? "custom-insurance-medicare-part-btn insurance-view-btn" : "insurance-view-btn"}>
                        <OverlayTrigger placement={"bottom"} overlay={exampleIconTooltip}>
                            <button className="btn btn-blue" onClick={handleModelShow}>Example</button>
                        </OverlayTrigger>
                    </div>
                    :
                    null
                    }

                </div>

                <div className="tds-reset-btn-grp">
                    <div className="tds-column-btn">
                        <div className="tds-btn-group">
                            <OverlayTrigger placement={"bottom"} overlay={editedIndexForInsurance!=="" && editedIndexForInsurance!==null ? updateIconTooltip : saveIconTooltip}>
                                <button className="btn btn-blue" onClick={()=>validateInsurance(true)}><i className="fa fa-plus"></i></button>
                            </OverlayTrigger>
                            <OverlayTrigger placement={"bottom"} overlay={resetIconTooltip}>
                                <button className="btn btn-blue" onClick={resetInsurance}><i className="fa fa-undo"></i></button>
                            </OverlayTrigger>
                        </div>
                    </div>
                </div>

                <div className="custom-tds-table custom-tds-insurance-table table-responsive">
                    {/* <BootstrapTable
                        data={insuranceData} 
                        bordered={true}>
                        <TableHeaderColumn width="12.5%"  dataFormat={formatInsuranceType} >Type</TableHeaderColumn>
                        <TableHeaderColumn width="12.5%"  isKey dataFormat={formatDisplayData} dataField={'settedBin'}>BIN</TableHeaderColumn>
                        <TableHeaderColumn width="12.5%"  dataFormat={formatDisplayData} formatExtraData={"10"} dataField={'settedPcn'}>PCN</TableHeaderColumn>
                        <TableHeaderColumn width="12.5%"  dataFormat={formatDisplayData} formatExtraData={"10"} dataField={'settedGroup'}>Group</TableHeaderColumn>
                        <TableHeaderColumn width="12.5%"  dataFormat={formatDisplayData} formatExtraData={"10"} dataField={'settedIdNumber'}>IdNumber</TableHeaderColumn>
                        <TableHeaderColumn width="12.5%"  dataFormat={formatDisplayData} dataField={'settedPersonCode'}>Person Code</TableHeaderColumn>
                        <TableHeaderColumn width="12.5%" dataFormat={setIconForInsurance} >Actions</TableHeaderColumn>
                    </BootstrapTable> */}

                    <table className="table">
                    <thead>
                        <tr>
                        <th scope="col">Type</th>
                        <th scope="col">BIN</th>
                        <th scope="col">PCN</th>
                        <th scope="col">Group</th>
                        <th scope="col">IdNumber</th>
                        <th scope="col">Person Code</th>
                        <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                         {
                            insuranceData.map((item) => (
                                <tr key={item.id}>
                                    <td>{formatInsuranceType(item)}</td>
                                    <td>{formatDisplayData(item.settedBin)}</td>
                                    <td>{formatDisplayData(item.settedPcn,10)}</td>
                                    <td>{formatDisplayData(item.settedGroup,10)}</td>
                                    <td>{formatDisplayData(item.settedIdNumber,10)}</td>
                                    <td>{formatDisplayData(item.settedPersonCode)}</td>
                                    <td>{setIconForInsurance(item)}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                    </table>

                </div>
            </div>
        </div>
    )
});
export default InsuranceTab;